import axios from '../core/axios';

import { ApiConstants } from './api-constants';
export class ZoomInfoService {
  static getTopUpdates = async (page = 1) => {
    return await (
      await axios.get(ApiConstants.ZOOMINFO.TOP_UPDATES.URL(page))
    ).data;
  };
  static getTargetAccounts = async (page = 1) => {
    return await (
      await axios.get(ApiConstants.ZOOMINFO.TARGET_ACCOUNTS.URL(page))
    ).data;
  };
  static getSuggestion = async (page = 1) => {
    return await (
      await axios.get(ApiConstants.ZOOMINFO.SUGGESTION.URL(page))
    ).data;
  };
  static searchZoominfo = async (query: string) => {
    return await (
      await axios.get(ApiConstants.ZOOMINFO.SEARCH_ZOOMINFO.URL(query))
    ).data;
  };
  static addTarget = async (payload: any) => {
    return await (
      await axios.post(ApiConstants.ZOOMINFO.ADD_TARGET.URL(), payload)
    ).data;
  };
  static getCompanyDetails = async (id: string) => {
    return await (
      await axios.get(ApiConstants.ZOOMINFO.COMPANY_DETAILS.URL(id))
    ).data;
  };
  static getCompanyEmployees = async (id: string, page: string, query?: any) => {
    return await (
      await axios.get(
        ApiConstants.ZOOMINFO.COMPANY_EMPLOYEE.URL(id, page) +
          ApiConstants.ZOOMINFO.COMPANY_EMPLOYEE.QUERY_PARAMS(query),
      )
    ).data;
  };
  static getCompanyNews = async (id: string, page = 1) => {
    return await (
      await axios.get(ApiConstants.ZOOMINFO.COMPANY_NEWS.URL(id, page))
    ).data;
  };
  static getCompanySimilar = async (id: string, page = 1) => {
    return await (
      await axios.get(ApiConstants.ZOOMINFO.COMPANY_SIMILAR.URL(id, page))
    ).data;
  };
  static getCompanySignals = async (id: string, page = 1) => {
    return await (
      await axios.get(ApiConstants.ZOOMINFO.COMPANY_SIGNALS.URL(id, page))
    ).data;
  };
  static addTag = async (id: string, payload: any) => {
    return await (
      await axios.post(ApiConstants.ZOOMINFO.ADD_TAG.URL(id), payload)
    ).data;
  };
  static deleteTag = async (id: string, tag: string) => {
    return await (
      await axios.delete(ApiConstants.ZOOMINFO.DELETE_TAG.URL(id, tag))
    ).data;
  };
  static deleteTarget = async (id: string) => {
    return await (
      await axios.delete(ApiConstants.ZOOMINFO.DELETE_TARGET.URL(id))
    ).data;
  };
  static addDeleteList = async (id: string, payload: any) => {
    return await (
      await axios.post(ApiConstants.ZOOMINFO.ADD_DELETE_LISTS.URL(id), payload)
    ).data;
  };
  static exportContacts = async (id: string, payload?: any) => {
    return await (
      await axios.post(ApiConstants.ZOOMINFO.EXPORT_CONTACT.URL(id), payload)
    ).data;
  };
  static getTags = async () => {
    return await (
      await axios.get(ApiConstants.ZOOMINFO.GET_TAGS.URL())
    ).data;
  };
  static getEmployeeDropdown = async (id: string) => {
    return await (
      await axios.get(ApiConstants.ZOOMINFO.EMPLOYEE_DROPDOWN.URL(id))
    ).data;
  };
  static exportCompanyData = async (id: string) => {
    return await (
      await axios.post(ApiConstants.ZOOMINFO.EXPORT_COMPANY_DATA.URL(id))
    ).data;
  };
  static dismissFeed = async (id: string) => {
    return await (
      await axios.post(ApiConstants.ZOOMINFO.DISMISS_FEED.URL(id))
    ).data;
  };
  static getHierchy = async (id: string) => {
    return await (
      await axios.get(ApiConstants.ZOOMINFO.CORPORATE_HIERCHY.URL(id))
    ).data;
  };
}
